import request from '@/utils/request';
/**获取列表数据 */
export function customerList(data) {
  return request.post('admin/customer/list', data);
}
/**删除 */
export function customerDelete(data) {
  return request.post('admin/customer/delete', data);
}
/**新增 */
export function addCustomer(data) {
  return request.post('admin/customer/store', data);
}
/**编辑 */
export function editCustomer(data) {
  return request.post('admin/customer/edit', data);
}
/**详情 */
export function customerDetail(data) {
  return request.post('admin/customer/detail', data);
}
export function customerResource(data) {
  return request.post('admin/customer/resource', data || {});
}
export function customerStatus(data) {
  return request.post('admin/customer/status', data || {});
}
export function templateConfig(data) {
  return request.post('admin/customer/templateConfig', data);
}
export function getCountryResource(data) {
  return request.post('admin/country/resource', data);
}